var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._t("body"),_c('el-row',[_c('el-col',{staticClass:"card-footer"},[_c('hr'),_vm._t("footer")],2)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }